// TS twin of iOS WheelDetectionKit `FramedReticle` (0.7.0, ?use_ios_ui).
//
// The ring the shopper frames their rim in. The overlay draws it and the
// Place button places at its centre, so both read this one geometry.
//
// The portrait lift is a PARAMETER, not iOS's fixed 40pt: on Android the
// depth placement samples the exact view centre (the depth pixel and the
// centre plane hit-test), so a lifted ring would frame one spot and place
// at another. main.ts passes 0.

export const RETICLE_RADIUS_FRACTION = 0.28

export interface TFramedReticle {
  readonly center: { readonly x: number; readonly y: number }
  readonly radius: number
}

export function framedReticle({
  viewSize,
  isLandscape,
  portraitLiftPx = 0,
}: {
  viewSize: { width: number; height: number }
  isLandscape: boolean
  portraitLiftPx?: number
}): TFramedReticle {
  return {
    center: {
      x: viewSize.width / 2,
      y: viewSize.height / 2 - (isLandscape ? 0 : portraitLiftPx),
    },
    radius: RETICLE_RADIUS_FRACTION * Math.min(viewSize.width, viewSize.height),
  }
}
